import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'

const Projects = ({openModal, setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          I have worked on a wide range of projects. Computer vision and Gen AI projects. Here are some of my projects.
        </Desc>
        <ToggleButtonGroup>
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'Computer vision' ?
            <ToggleButton active value="Computer vision" onClick={() => setToggle('Computer vision')}>Computer Vision</ToggleButton>
            :
            <ToggleButton value="Computer vision" onClick={() => setToggle('Computer vision')}>Computer Vision</ToggleButton>
          }
          <Divider />
          {toggle === 'Gen AI' ?
            <ToggleButton active value="Gen AI" onClick={() => setToggle('Gen AI')}>Gen AI</ToggleButton>
            :
            <ToggleButton value="Gen AI" onClick={() => setToggle('Gen AI')}>Gen AI</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard key={project.id} project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {toggle !== 'all' && projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard key={project.id} project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects
